import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import Hero from "./components/Hero";
import TrustBar from "./components/TrustBar";
import ServicesOverview from "./components/ServicesOverview";
import AIAnswerBlock from "./components/AIAnswerBlock";
import Process from "./components/Process";
import WhyChooseUs from "./components/WhyChooseUs";
import ServiceAreas from "./components/ServiceAreas";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import FinalCTA from "./components/FinalCTA";

export default function Home() {
  return (
    <div className="bg-charcoal font-sans">
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <ServicesOverview />
        <AIAnswerBlock />
        <Process />
        <WhyChooseUs />
        <ServiceAreas />
        <Testimonials />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-0 left-0 right-0 lg:hidden z-40 bg-charcoal-100/95 backdrop-blur-md border-t border-white/10 px-4 py-3 flex gap-3">
        <a
          href="tel:4154539180"
          className="flex-1 flex items-center justify-center gap-2 border border-gold text-gold font-sans text-sm font-semibold py-3 rounded whitespace-nowrap cursor-pointer"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-phone-line text-sm"></i>
          </div>
          Call Now
        </a>
        <button
          onClick={() => {
            const el = document.querySelector("#contact");
            if (el) el.scrollIntoView({ behavior: "smooth" });
          }}
          className="flex-1 bg-gold text-charcoal font-sans text-sm font-semibold py-3 rounded whitespace-nowrap cursor-pointer"
        >
          Reserve Storage
        </button>
      </div>
    </div>
  );
}
